import { Environment } from "../utils/aiprise-fetch.js";

export type AiPriseElementProps = {
  mode: Environment;
  "template-id": string;
  "session-id"?: string;
  "callback-url"?: string;
  "events-callback-url"?: string;
  "client-reference-id"?: string;
  "client-reference-data"?: string;
  "user-profile-id"?: string;
  "business-profile-id"?: string;
  "user-data"?: string;
  "business-data"?: string;
  "additional-info"?: string;
  "ui-options"?: string;
  "verification-options"?: string;
  "associated-email"?: string;
  icon?: string;
  theme?: string; // JSON (theme_options)
};
